export default __webpack_public_path__ + "static/media/logo_renfe.09e2789d.svg";